import { render, staticRenderFns } from "./display-field-price.vue?vue&type=template&id=bb45446e&scoped=true&"
import script from "./display-field-price.ts?vue&type=script&lang=ts&"
export * from "./display-field-price.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-price.scss?vue&type=style&index=0&id=bb45446e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb45446e",
  null
  
)

export default component.exports